<template>
  <div ref="container"></div>
</template>

<script lang="ts" setup>
import { play } from '@voomp/play-back'
import { ref, onMounted } from 'vue'
import Cookies from 'js-cookie'
import { useUIStore } from '@/store/useUIStore'

const apiSpec = play._http.openAPI.toJSON()

const container = ref(null)

const uiStore = useUIStore()

onMounted(() => {
  // Carrega o script do Scalar
  const script = document.createElement('script')
  script.src = 'https://cdn.jsdelivr.net/npm/@scalar/api-reference'
  
  script.onload = () => {
    const token = Cookies.get('auth_greennCourse')

    setTimeout(async () => {
      const permissao = await globalThis.navigator.permissions.query({ 
        name: 'content_copy' 
      });

      if (permissao.state === 'granted' || permissao.state === 'prompt') {
        globalThis.navigator.clipboard.writeText(token)
      }

      permissao.addEventListener('change', () => {
        globalThis.navigator.clipboard.writeText(token)
      });
    }, 1000);

    // Usa a API global Scalar
    window.Scalar.createApiReference(container.value, {
      spec: {
        content: apiSpec
      },
      servers: [
        {
          url: import.meta.env.VUE_APP_API_HOST,
          description: 'HOST'
        }
      ],
      theme: 'deepSpace',
      darkMode: uiStore.getTheme() === 'dark',
      layout: 'modern',
      authentication: {
        preferredSecurityScheme: 'apiKeyAuth',
        apiKey: {
          token
        }
      },
    })
  }
  
  document.head.appendChild(script)
})
</script>
